import { useEffect, useState } from 'react';
import { Divider, Space, Spin, Typography } from 'antd';
import { DISPLAY_DATE_VARIANTS, formatDateForDisplay } from '@shared/utils/dateUtils';
import { EXECUTION_DETAILS_POLL_INTERVAL_MS } from '../../hooks/useQuotations';

const { Text } = Typography;

const executionDetailsPollIntervalSeconds = EXECUTION_DETAILS_POLL_INTERVAL_MS / 1000;

const getSyncStatusParts = ({ dataUpdatedAt, now }) => {
  const secondsSinceUpdate = dataUpdatedAt
    ? Math.max(0, Math.floor((now - dataUpdatedAt) / 1000))
    : 0;
  const secondsUntilNext = Math.max(0, executionDetailsPollIntervalSeconds - secondsSinceUpdate);

  const lastUpdatedAtLabel = formatDateForDisplay(dataUpdatedAt, { variant: DISPLAY_DATE_VARIANTS.LOG });

  return {
    lastUpdatedLabel: lastUpdatedAtLabel
      ? `Última actualización: ${lastUpdatedAtLabel}`
      : null,
    nextUpdateLabel: `Próxima actualización en ${secondsUntilNext} s`,
  };
};

export const SyncStatus = ({ isPolling, isFetching, dataUpdatedAt }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!isPolling) return undefined;

    const intervalId = setInterval(() => setNow(Date.now()), 1000); // Actualiza la hora actual cada segundo para recalcular el tiempo hasta la próxima actualización

    return () => clearInterval(intervalId);
  }, [isPolling]);

  if (!isPolling) {
    return null;
  }

  const { lastUpdatedLabel, nextUpdateLabel } = getSyncStatusParts({ dataUpdatedAt, now });

  return (
    <Space
      wrap
      size='small'
      split={<Divider type='vertical' style={{ margin: 0, borderInlineStartWidth: 2 }} />}
      style={{
        textAlign: 'left',
        lineHeight: 1,
        fontSize: '0.8em',
        rowGap: 0,
      }}
    >
      {lastUpdatedLabel && (
        <Text type='secondary' style={{ fontSize: 'inherit' }}>
          {lastUpdatedLabel}
        </Text>
      )}
      <Space size='small'>
        <Text type='secondary' style={{ fontSize: 'inherit' }}>
          {nextUpdateLabel}
        </Text>
        <Spin size='small' spinning={isFetching} />
      </Space>
    </Space>
  );
};
